import { render, staticRenderFns } from "./host-detail.html?vue&type=template&id=07f8d71e&scoped=true&external"
import script from "./host-detail.js?vue&type=script&lang=js&external"
export * from "./host-detail.js?vue&type=script&lang=js&external"
import style0 from "./host-detail.scss?vue&type=style&index=0&id=07f8d71e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f8d71e",
  null
  
)

export default component.exports